import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dbffe7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "fs-7 p-3 mb-4 rounded-1 while-spaces",
    innerHTML: __props.title
  }, null, 8, _hoisted_1))
}
}

})